export default "__VITE_ASSET__CyydX813__"